var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "#b6b6b6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2169_15133)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2144 3.4467L12.8257 2.05806C12.0935 1.32582 10.9063 1.32582 10.1741 2.05806L8.78544 3.4467H6.8216C5.78607 3.4467 4.9466 4.28616 4.9466 5.3217V7.28553L3.55796 8.67417C2.82573 9.4064 2.82573 10.5936 3.55796 11.3258L4.9466 12.7145V14.6783C4.9466 15.7138 5.78607 16.5533 6.8216 16.5533H8.78544L10.1741 17.9419C10.9063 18.6742 12.0935 18.6742 12.8257 17.9419L14.2144 16.5533H16.1782C17.2137 16.5533 18.0532 15.7138 18.0532 14.6783V12.7145L19.4418 11.3258C20.1741 10.5936 20.1741 9.40641 19.4418 8.67417L18.0532 7.28553V5.3217C18.0532 4.28616 17.2137 3.4467 16.1782 3.4467H14.2144ZM13.5135 4.51364C13.6308 4.63085 13.7897 4.6967 13.9555 4.6967H16.1782C16.5234 4.6967 16.8032 4.97652 16.8032 5.3217V7.54441C16.8032 7.71018 16.8691 7.86915 16.9863 7.98636L18.558 9.55806C18.802 9.80213 18.802 10.1979 18.558 10.4419L16.9863 12.0136C16.8691 12.1308 16.8032 12.2898 16.8032 12.4556V14.6783C16.8032 15.0235 16.5234 15.3033 16.1782 15.3033H13.9555C13.7897 15.3033 13.6308 15.3691 13.5135 15.4864L11.9418 17.0581C11.6978 17.3021 11.302 17.3021 11.058 17.0581L9.48626 15.4864C9.36905 15.3691 9.21008 15.3033 9.04432 15.3033H6.8216C6.47643 15.3033 6.1966 15.0235 6.1966 14.6783V12.4556C6.1966 12.2898 6.13076 12.1308 6.01355 12.0136L4.44185 10.4419C4.19777 10.1979 4.19777 9.80213 4.44185 9.55806L6.01355 7.98636C6.13076 7.86915 6.1966 7.71018 6.1966 7.54441V5.3217C6.1966 4.97652 6.47643 4.6967 6.8216 4.6967H9.04432C9.21008 4.6967 9.36905 4.63085 9.48626 4.51364L11.058 2.94194C11.302 2.69786 11.6978 2.69786 11.9418 2.94194L13.5135 4.51364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9555 4.6966C13.7897 4.6966 13.6308 4.63076 13.5135 4.51355L11.9418 2.94185C11.6978 2.69777 11.302 2.69777 11.058 2.94185L9.48626 4.51355C9.36905 4.63076 9.21008 4.6966 9.04432 4.6966H6.8216C6.47643 4.6966 6.1966 4.97643 6.1966 5.3216V7.54432C6.1966 7.71008 6.13076 7.86905 6.01355 7.98626L4.44185 9.55796C4.19777 9.80204 4.19777 10.1978 4.44185 10.4418L6.01355 12.0135C6.13076 12.1308 6.1966 12.2897 6.1966 12.4555V14.6782C6.1966 15.0234 6.47643 15.3032 6.8216 15.3032H9.04432C9.21008 15.3032 9.36905 15.3691 9.48626 15.4863L11.058 17.058C11.302 17.302 11.6978 17.302 11.9418 17.058L13.5135 15.4863C13.6308 15.3691 13.7897 15.3032 13.9555 15.3032H16.1782C16.5234 15.3032 16.8032 15.0234 16.8032 14.6782V12.4555C16.8032 12.2897 16.8691 12.1308 16.9863 12.0135L18.558 10.4418C18.802 10.1978 18.802 9.80204 18.558 9.55796L16.9863 7.98626C16.8691 7.86905 16.8032 7.71008 16.8032 7.54432V5.3216C16.8032 4.97643 16.5234 4.6966 16.1782 4.6966H13.9555Z",
    fill: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8587 8.35866L10.6667 12.5506L8.55811 10.442L9.44199 9.55811L10.6667 10.7828L13.9748 7.47478L14.8587 8.35866Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2169_15133",
    x: -1,
    y: -1.25,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_15133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2169_15133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.6f4a67a18bf3f4ada28098d39fb3fb80.svg";
export { ForwardRef as ReactComponent };